// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"213":"779c46f7","506":"9bfd7427","531":"2f002a57","692":"6d686b6e","728":"404dd7f4","867":"0ae81b69"}[chunkId] + ".chunk.css";
};